<div [attr.data-automation-e2e-selector]="visible ? 'isLoading' : 'isLoaded'"
  [ngClass]="visible ? 'show loading c-loader' : 'no-loader'">
  <ng-content *ngIf="renderContent || !visible"></ng-content>
</div>